
import { Col, Modal } from 'antd';
import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
import useWindowSize from '../../utils/hooks/useWindowSize';
import { GREY_WHITE, GRID_LG, GRID_MD, GRID_SM } from '../../styles';
import Icon from '../../styles/Icon';
import VideoPlaceholder from './Video/VideoPlaceholder';

const AboutCodesVideo = (
  {
    src,
    color,
    url,
    background
  }: {
    url: string,
    src:string,
    color?: string,
    background?: string
  }
) => {
  const { width } = useWindowSize();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const videoSize = () => {
    if (width >= GRID_LG) return {
      width: 960, height: 540
    };
    if (width >= GRID_MD) return {
      width: 720, height: 405
    };
    if (width >= GRID_SM) return {
      width: 480, height: 270
    };
    return {
      width: 320, height: '100%'
    };
  };
  const showVideo = () => {
    if (width >= GRID_SM){
      setIsModalVisible(true);
    } else {
      window.open(url, '_blank');
    }
  };
  return (
    <VideoCol background={background} color={color ?? 'black'}>
      <VideoPlaceholder
        showVideo={showVideo}
        src={src}
        color={color}
      />
      <Modal
        onCancel={() =>
          setIsModalVisible(false)}
        visible={isModalVisible}
        footer={false}
        title={(
          <Icon
            height="18"
            width="18"
            fill="white"
            iconType="PLAY"
          />
)}
        destroyOnClose
        width={videoSize().width + 40}
        style={{ background: 'none !important' }}
      >
        <Player
          url={url}
          volume={0.5}
          playing={isModalVisible}
          height={videoSize().height}
          width={videoSize().width}
          controls
        />
      </Modal>
    </VideoCol>
  );
};

export default AboutCodesVideo;
export const Player = styled(ReactPlayer)`
  width: 960px;
`;

const VideoCol = styled(Col)<{ background?: string, color: string }>`
  background-color: ${({ background }) =>
    background ?? GREY_WHITE};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  margin-top: 48px;
  @media only screen and (max-width: 767px) {
    border-color: ${({ color }) =>
    color};
    border-width: 1px;
    border-style: solid;
	}
`;
